import { createNaturalDivisionTask, randInt, quotientSplitExplanation } from "./sharedNaturalDivision";

function pickData() {
  for (let i = 0; i < 300; i += 1) {
    const b = randInt(3, 7);
    const firstQuotient = 10;
    const secondQuotient = randInt(2, 9);
    const result = firstQuotient + secondQuotient;
    const firstPart = b * firstQuotient;
    const secondPart = b * secondQuotient;
    const a = firstPart + secondPart;
    if (a >= 40 && a < 100 && a % 10 !== 0) {
      return { a, b, firstPart, secondPart, firstQuotient, secondQuotient, result };
    }
  }
  return { a: 45, b: 3, firstPart: 30, secondPart: 15, firstQuotient: 10, secondQuotient: 5, result: 15 };
}

const mod = createNaturalDivisionTask({
  type: "NaturalDivConvenientSplitTask",
  pickData,
  explain: quotientSplitExplanation,
});

export const generateTask = mod.generateTask;
export const renderTask = mod.renderTask;
export const renderInput = mod.renderInput;
export const checkAnswer = mod.checkAnswer;
export const renderAnswer = mod.renderAnswer;
export const renderUserAnswer = mod.renderUserAnswer;
export const renderExplanation = mod.renderExplanation;
